import React from 'react';
import { Info, X } from 'lucide-react';

function NotificationModal({ onClose, message, title = "Notification" }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
      <div className="w-full max-w-md p-6 rounded-lg bg-white dark:bg-card/95 shadow-xl border border-gray-400 dark:border-border/50">
        <div className="mb-4">
          <div className="flex items-center mb-3">
            <div className="size-8 rounded-full bg-blue-500/10 text-blue-500 flex items-center justify-center mr-3">
              <Info className="h-4 w-4" />
            </div>
            <h2 className="text-lg font-semibold text-foreground">{title}</h2>
          </div>
          <p className="text-sm text-gray-700 dark:text-muted-foreground">
            {message}
          </p>
        </div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 transition-colors flex items-center"
          >
            <X className="h-4 w-4 mr-2" />
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default NotificationModal; 